const errorOrder = [
  'schema.periodName',
  'permission.add',

  'schema.topsideFlag',
  'tree.allowTopside',
  'tree.forceTopside',
  'permission.topside',

  'schema.companyCode',
  'tree.wrongObligation',
  'companyCode.hasInvalidTBE',
  'permission.assignment',

  'schema.taxYear',
  'tree.wrongTaxYear',

  'schema.countryTaxType',
  'tree.wrongCountryTaxType',

  'schema.entryType',
  'tree.wrongEntryType',

  'schema.entryActivity',
  'tree.wrongEntryActivity',
  'tree.allowEntry',

  'schema.bookType',
  'tree.wrongBookType',

  'schema.payableTag',
  'payableTag.dissallowed',
  'payableTag.invalid',

  'schema.account',
  'tree.invalidAccount',
  'tree.accountOverride',
  'tree.requireAccount',
  'tree.accountNotAllowed',
  'account.sameAccounts',
  'client.reclassAccountNotAllowed',
  'client.reclassAccountRequired',
  'client.reclassTaxYearNotAllowed',
  'client.reclassTaxYearRequired',

  'schema.netAmount',

  'schema.grossAmount',
  'tree.allowGross',
  'permission.canUnlinkNetGrossAmount',

  'schema.fromAccount',
  'tree.allowFromAccount',

  'schema.glAccountOverride',
  'tree.wrongGlAccount',
  'tree.allowSelectingGlAccount',
  'glAccount.missingOrNotEnabledGlAccount',

  'schema.fbosFlag',

  'schema.comment',
];


export const sortErrors = errors => {
  const inOrder = errors.filter(({ type }) => errorOrder.includes(type));
  const notInOrder = errors.filter(({ type }) => !errorOrder.includes(type));

  return [
    ...inOrder.sort((a, b) => errorOrder.indexOf(a.type) - errorOrder.indexOf(b.type)),
    ...notInOrder,
  ];
};
